import gql from 'graphql-tag';

const Query = {
  findCompanies: gql`
    query findCompanies($filters: CompanyFiltersInput, $pagination: PageInfoInput, $orderBy: CompanyOrderByInput) {
      findCompanies(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
        nbHits
        hits {
          id
          code
          name
        }
      }
    }
  `,
  findContactInfoConpanyInfos: gql`
    query findContactInfoConpanyInfos($contactsInfoId: Int!) {
      findContactInfoConpanyInfos(contactsInfoId: $contactsInfoId) {
        id
        name
        legal
        address
        address_bis
        zipcode
        city
        email
        phone
        siret
        iban
        share_capital_amount
        vat_rate
      }
    }
  `,
  getFonctionAndService: gql`
    query getFonctionAndService($page: Int, $pageSize: Int) {
      getFonctionAndService(page: $page, pageSize: $pageSize) {
        nbHits
        hits {
          service
          fonction
        }
      }
    }
  `,
  findContactsAndInfos: gql`
    query findContactsAndInfos(
      $filters: ContactsFilterTrombi
      $page: Int
      $pageSize: Int
      $orderBy: contactOrderByInput
    ) {
      findContactsAndInfos(filters: $filters, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
        nbHits
        hits {
          id
          email
          isStaff
          isAgent
          createdAt
          updatedAt
          contactsInfos {
            id
            name
            firstname
            city
            phone
            address
            updatedAt
            zipcode
            company {
              id
              name
            }
            department
            service
            fonction
            sources {
              actif
              referer
            }
            departureDate
            document {
              public_url
              display_location
              category
            }
          }
        }
      }
    }
  `,
  findTrombinoscope: gql`
    query findTrombinoscope($filters: ContactsFilterTrombi, $page: Int, $pageSize: Int, $orderBy: contactOrderByInput) {
      findTrombinoscope(filters: $filters, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
        nbHits
        hits {
          id
          email
          isStaff
          isAgent
          createdAt
          updatedAt
          contactsInfos {
            id
            name
            firstname
            city
            phone
            address
            updatedAt
            zipcode
            company {
              id
              name
            }
            department
            service
            fonction
            sources {
              actif
              referer
            }
            departureDate
            document {
              public_url
              display_location
              category
            }
          }
        }
      }
    }
  `,

  findDeletedContactsAndInfos: gql`
    query findDeletedContactsAndInfos($filters: ContactsFilterTrombi, $page: Int, $pageSize: Int) {
      findDeletedContactsAndInfos(filters: $filters, page: $page, pageSize: $pageSize) {
        nbHits
        hits {
          id
          email
          isStaff
          isAgent
          contactsInfos {
            id
            name
            firstname
            city
            phone
            address
            updatedAt
            zipcode
            company {
              id
              name
            }
            department
            service
            fonction
            sources {
              actif
              referer
            }
            departureDate
            document {
              public_url
              display_location
              category
            }
          }
        }
      }
    }
  `,
  contacts: gql`
    query contacts($filters: ContactsFiltersInput, $typeOperator: String) {
      contacts(filters: $filters, typeOperator: $typeOperator) {
        id
        email
        contactsInfos {
          name
          firstname
          type
        }
      }
    }
  `,
  typeContacts: gql`
    query typeContacts($type: ContactType) {
      typeContacts(type: $type) {
        id
        email
      }
    }
  `,
  findContactsByNameOrEmail: gql`
    query findContactsByNameOrEmail($search: ContactsSearchInput) {
      findContactsByNameOrEmail(search: $search) {
        id
        email
        contactsInfos {
          name
          firstname
        }
      }
    }
  `,
  formatSelectContactsByCompanyCode: gql`
    query formatSelectContactsByCompanyCode(
      $code: String
      $searchName: String
      $searchEmail: String
      $searchLocation: String
      $isAgent: Boolean
      $isStaff: Boolean
      $offset: Int
      $limit: Int
      $actif: Boolean
    ) {
      formatSelectContactsByCompanyCode(
        code: $code
        searchName: $searchName
        searchEmail: $searchEmail
        searchLocation: $searchLocation
        isAgent: $isAgent
        isStaff: $isStaff
        offset: $offset
        limit: $limit
        actif: $actif
      ) {
        label
        id
        contactsInfoId
        externalId
        avatar
      }
    }
  `,
  contactInfosByCompanyCode: gql`
    query contactInfosByCompanyCode(
      $code: String
      $searchName: String
      $searchEmail: String
      $searchLocation: String
      $isAgent: Boolean
      $isStaff: Boolean
      $offset: Int
      $limit: Int
    ) {
      contactInfosByCompanyCode(
        code: $code
        searchName: $searchName
        searchEmail: $searchEmail
        searchLocation: $searchLocation
        isAgent: $isAgent
        isStaff: $isStaff
        offset: $offset
        limit: $limit
      ) {
        hits {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          contact {
            id
            email
          }
          sources {
            id
            referer
            source
          }
          company {
            name
            code
          }
        }
        nbHits
      }
    }
  `,
  contactInfosAssocs: gql`
    query findContactInfosAssocs(
      $currentUser: String
      $code: String
      $id: Int!
      $searchName: String
      $searchEmail: String
      $searchLocation: String
      $isAgent: Boolean
      $isStaff: Boolean
      $offset: Int
      $limit: Int
    ) {
      findContactInfosAssocs(
        currentUser: $currentUser
        code: $code
        id: $id
        searchName: $searchName
        searchEmail: $searchEmail
        searchLocation: $searchLocation
        isAgent: $isAgent
        isStaff: $isStaff
        offset: $offset
        limit: $limit
      ) {
        hits {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          scale
          contact {
            id
            email
          }
          sources {
            id
            referer
            source
          }
          company {
            name
            code
          }
        }
        nbHits
      }
    }
  `,
  contact: gql`
    query contact($id: Int!) {
      contact(id: $id) {
        id
        email
        isAgent
        isStaff
        isCandidate
        originCandidate
        contactsInfos {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          birth_date
          birth_place
          birth_country
          birth_name
          father_name
          father_firstname
          mother_name
          mother_firstname
          nationality
          scale
          externalRsacCity
          externalRsacNumber
          statutEntrepreneur
          isMLM
          sources {
            id
            referer
            source
            section
            actif
            externalId
            uuid
          }
          company {
            id
            name
            code
          }
          document {
            public_url
            display_location
            category
          }
          vat_rate
          contractsPeriods {
            siret
            siretDuo
          }
        }
      }
    }
  `,
  contactInfo: gql`
    query contactInfo($id: Int!) {
      contactInfo(id: $id) {
        id
        civility
        name
        firstname
        phone
        street_number
        address
        address_bis
        city
        zipcode
        region
        department
        country
        latitude
        longitude
        maritalStatus
        type
        scale
        birth_date
        birth_place
        externalRsacNumber
        externalRsacCity
        externalCompanyName
        statutEntrepreneur
        contact {
          id
          email
          isAgent
        }
        sources {
          id
          referer
          source
        }
        company {
          name
          code
        }
        mandatory {
          id
          agency
          directorName
          address
          cciCardNum
          cciRegion
          guaranteeCompany
          guaranteePrice
          specialAccountNum
          bank
          logoUrl
          comment
          mandatoryName
          mandatoryEmail
          mandatoryAddress
          createdAt
          updatedAt
        }
        vat_rate
      }
    }
  `,
  contactInfoTrainingsSessions: gql`
    query getContactInfosTrainingsSessions($id: Int!) {
      getContactInfosTrainingsSessions(id: $id) {
        id
        trainingsSessions {
          id
          duration
          reference
          title
          provider
          provider_address1
          provider_address2
          provider_zip
          provider_city
          startDate
          endDate
          createdDate
          object_type
          status
        }
        trainingsSessionsContactsInfosAssocs {
          status
          sessionCompletionDate
          contactsInfoId
        }
      }
    }
  `,
  companies: gql`
    {
      companies {
        hits {
          id
          name
          code
        }
      }
    }
  `,
  contactAssoc: gql`
    query findContactsAssocs($id: Int!) {
      findContactsAssocs(id: $id) {
        email
      }
    }
  `,

  contactsSummaryFilleuls: gql`
    query summaryFilleuls($contactInfoId: Int) {
      summaryFilleuls(contactInfoId: $contactInfoId) {
        name
        firstname
        phone
        commissionnementsTotal
        document {
          id
          public_url
        }
      }
    }
  `,

  contactsParrainage: gql`
    query contacts($email: String) {
      contacts(filters: { email: $email }) {
        id
        email
        isStaff
        isAgent
        contactsInfos {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          zipcode
          city
          sources {
            actif
            source
            referer
            section
          }
          document {
            public_url
          }
          contractsPeriods {
            contractSignatureDate
            actif
          }
          infosParrainages {
            parrainageDate
            type
            typeLabel
            origin
            montantPrimeParrainage
            contactInfoParrain {
              id
              name
              civility
            }
          }
          commissionnements {
            baseCalculHt
            commissionnementHT
            montantCommissionnementVerseHT
            verseLe
            transaction {
              dateEffectiveCompromis
            }
          }
          contactsInfosFilleuls {
            id
            civility
            name
            firstname
            contact {
              email
            }
            phone
            street_number
            address
            address_bis
            zipcode
            city
            sources {
              actif
              source
              referer
              section
            }
            document {
              public_url
            }
            contractsPeriods {
              contractSignatureDate
              actif
            }
            infosParrainages {
              parrainageDate
              type
              typeLabel
              origin
              montantPrimeParrainage
              contactInfoParrain {
                id
                name
                civility
              }
            }
            commissionnements {
              baseCalculHt
              commissionnementHT
              montantCommissionnementVerseHT
              verseLe
              transaction {
                dateEffectiveCompromis
              }
            }
            contactsInfosFilleuls {
              id
              civility
              name
              firstname
              contact {
                email
              }
              phone
              street_number
              address
              address_bis
              zipcode
              city
              sources {
                actif
                source
                referer
                section
              }
              document {
                public_url
              }
              contractsPeriods {
                contractSignatureDate
                actif
              }
              infosParrainages {
                parrainageDate
                type
                typeLabel
                origin
                contactInfoParrain {
                  id
                  name
                  civility
                }
              }
              commissionnements {
                baseCalculHt
                commissionnementHT
                montantCommissionnementVerseHT
                verseLe
                transaction {
                  dateEffectiveCompromis
                }
              }
              contactsInfosFilleuls {
                id
                civility
                name
                firstname
                contact {
                  email
                }
                phone
                street_number
                address
                address_bis
                zipcode
                city
                sources {
                  actif
                  source
                  referer
                  section
                }
                document {
                  public_url
                }
                contractsPeriods {
                  contractSignatureDate
                  actif
                }
                infosParrainages {
                  parrainageDate
                  type
                  typeLabel
                  origin
                  contactInfoParrain {
                    id
                    name
                    civility
                  }
                }
                commissionnements {
                  baseCalculHt
                  commissionnementHT
                  montantCommissionnementVerseHT
                  verseLe
                  transaction {
                    dateEffectiveCompromis
                  }
                }
                contactsInfosFilleuls {
                  id
                  civility
                  name
                  firstname
                  contact {
                    email
                  }
                  phone
                  street_number
                  address
                  address_bis
                  zipcode
                  city
                  sources {
                    actif
                    source
                    referer
                    section
                  }
                  document {
                    public_url
                  }
                  contractsPeriods {
                    contractSignatureDate
                    actif
                  }
                  infosParrainages {
                    parrainageDate
                    type
                    typeLabel
                    origin
                    contactInfoParrain {
                      id
                      name
                      civility
                    }
                  }
                  commissionnements {
                    baseCalculHt
                    commissionnementHT
                    montantCommissionnementVerseHT
                    verseLe
                    transaction {
                      dateEffectiveCompromis
                    }
                  }
                  contactsInfosFilleuls {
                    id
                    civility
                    name
                    firstname
                    contact {
                      email
                    }
                    phone
                    street_number
                    address
                    address_bis
                    zipcode
                    city
                    sources {
                      actif
                      source
                      referer
                      section
                    }
                    document {
                      public_url
                    }
                    contractsPeriods {
                      contractSignatureDate
                      actif
                    }
                    infosParrainages {
                      parrainageDate
                      type
                      typeLabel
                      origin
                      contactInfoParrain {
                        id
                        name
                        civility
                      }
                    }
                    commissionnements {
                      baseCalculHt
                      commissionnementHT
                      montantCommissionnementVerseHT
                      verseLe
                      transaction {
                        dateEffectiveCompromis
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,

  companyDashboardState: gql`
    query findDashboardState($companyId: Int!) {
      findDashboardState(companyId: $companyId) {
        note
        promo {
          link
          image {
            id
            public_url
          }
        }
      }
    }
  `,

  isRegisterChangeFormula: gql`
    query isRegisterChangeFormula {
      isRegisterChangeFormula
    }
  `,

  isExReflex: gql`
    query isExReflex {
      isExReflex
    }
  `,

  contactIrisByAdrress: gql`
    query findContactIrisByAdrress($address: String) {
      findContactIrisByAdrress(address: $address) {
        id
        civility
        name
        firstname
        phone
        street_number
        address
        address_bis
        city
        zipcode
        region
        department
        contactInfoPictures {
          id
          public_url
        }
        iris {
          id
        }
        phone
        contact {
          id
          email
        }
      }
    }
  `,
};

const Mutation = {
  deleteDepartureDateOfContact: gql`
    mutation deleteDepartureDateOfContact($contactId: Int) {
      deleteDepartureDateOfContact(contactId: $contactId) {
        id
        email
        isAgent
        isStaff
        isCandidate
        contactsInfos {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          birth_date
          birth_place
          birth_country
          birth_name
          father_name
          father_firstname
          mother_name
          mother_firstname
          nationality
          scale
          sources {
            id
            referer
            source
            section
          }
          company {
            id
            name
            code
          }
          document {
            public_url
            display_location
            category
          }
          vat_rate
        }
      }
    }
  `,

  addDepartureDateToContact: gql`
    mutation addDepartureDateToContact($contactId: Int) {
      addDepartureDateToContact(contactId: $contactId) {
        id
        email
        isAgent
        isStaff
        isCandidate
        contactsInfos {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          birth_date
          birth_place
          birth_country
          birth_name
          father_name
          father_firstname
          mother_name
          mother_firstname
          nationality
          scale
          sources {
            id
            referer
            source
            section
          }
          company {
            id
            name
            code
          }
          document {
            public_url
            display_location
            category
          }
          vat_rate
        }
      }
    }
  `,

  createContact: gql`
    mutation createContact($data: CreateContactDataInput) {
      createContact(data: $data) {
        id
        email
        isAgent
        isStaff
        contactsInfos {
          id
          civility
          name
          firstname
          phone
          street_number
          address
          address_bis
          city
          zipcode
          region
          department
          country
          latitude
          longitude
          maritalStatus
          type
          contact {
            id
            email
          }
          sources {
            id
            referer
            source
          }
          company {
            name
            code
          }
        }
      }
    }
  `,

  editContactFunctionAndService: gql`
    mutation editContactFunctionAndService($service: String, $fonction: String, $contactInfoId: Int!, $newBU: Int) {
      editContactFunctionAndService(
        service: $service
        fonction: $fonction
        contactInfoId: $contactInfoId
        newBU: $newBU
      ) {
        id
        name
        firstname
        city
        phone
        address
        updatedAt
        zipcode
        company {
          id
          name
        }
        department
        fonction
        service
        company {
          name
          code
        }
      }
    }
  `,

  uploadPromoImagesDashboard: gql`
    mutation uploadPromoImagesDashboard($companyId: Int!, $files: [Upload!]!) {
      uploadPromoImagesDashboard(companyId: $companyId, files: $files) {
        id
        filename
        type
        public_url
      }
    }
  `,
  saveCompanyDashboard: gql`
    mutation saveCompanyDashboard($params: CompanyDashboardInput!) {
      saveCompanyDashboard(params: $params)
    }
  `,
  deletePromoCompanyDashboard: gql`
    mutation deletePromoCompanyDashboard($params: CompanyDashboardInput!) {
      deletePromoCompanyDashboard(params: $params)
    }
  `,
  updateContact: gql`
    mutation updateContact($contactId: Int!, $isStaff: Boolean, $isAgent: Boolean) {
      updateContact(contactId: $contactId, data: { isStaff: $isStaff, isAgent: $isAgent })
    }
  `,
  updateContactInfo: gql`
    mutation updateContactInfo(
      $contactInfoId: Int!
      $latitude: Float
      $longitude: Float
      $civility: ContactCivility
      $name: String
      $firstname: String
      $phone: String
      $street_number: String
      $address: String
      $address_bis: String
      $city: String
      $zipcode: String
      $department: String
      $region: String
      $country: String
      $vat_rate: Float
      $email: String
      $birth_date: Date
      $birth_place: String
      $externalRsacNumber: Int
      $externalRsacCity: String
      $externalCompanyName: String
      $maritalStatus: String
    ) {
      updateContactInfo(
        contactInfoId: $contactInfoId
        data: {
          latitude: $latitude
          longitude: $longitude
          civility: $civility
          name: $name
          firstname: $firstname
          phone: $phone
          street_number: $street_number
          address: $address
          address_bis: $address_bis
          city: $city
          zipcode: $zipcode
          department: $department
          region: $region
          country: $country
          vat_rate: $vat_rate
          email: $email
          birth_date: $birth_date
          birth_place: $birth_place
          externalRsacNumber: $externalRsacNumber
          externalRsacCity: $externalRsacCity
          externalCompanyName: $externalCompanyName
          maritalStatus: $maritalStatus
        }
      )
    }
  `,
  deleteContact: gql`
    mutation deleteContact($contactId: Int!) {
      deleteContact(contactId: $contactId)
    }
  `,
  registrationChangeFormula: gql`
    mutation registrationChangeFormula($demand: changeFormulaType!) {
      registrationChangeFormula(demand: $demand)
    }
  `,
  attributeIrisToContact: gql`
    mutation attributeIrisToContact($contactId: Int!, $irisCode: String!) {
      attributeIrisToContact(contactId: $contactId, irisCode: $irisCode) {
        id
        irisCode
        contactsInfoId
      }
    }
  `,
};

export default {
  Query,
  Mutation,
};
